import { render, staticRenderFns } from "./PlaylistAdminItem.vue?vue&type=template&id=098dcce8"
import script from "./PlaylistAdminItem.vue?vue&type=script&lang=js"
export * from "./PlaylistAdminItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports